module.exports = __webpack_public_path__ + "4afcb6658652d69cf4dd77748dce3615.png";